module.exports = __webpack_public_path__ + "media/images/badges/rumble/milestone-50-Inactive-Rumble-45c1cc5ceb7473a8f8f413def91d8cec.png";